<template>
  <div class="min-h-screen bg-zinc-900 flex flex-col items-center justify-center p-4 font-nunito">
    <!-- Logo -->
    <div class="flex items-center mb-10">
      <img src="@/assets/bot_express_logo.png" alt="Logo" class="h-auto w-[180px] sm:w-[280px]">
    </div>

    <!-- Container principal -->
    <div class="w-full max-w-md">
      <!-- Card de seleção -->
      <div class="bg-white/5 rounded-xl overflow-hidden">
        <div class="p-6">
          <!-- Cabeçalho -->
          <div class="mb-6 text-center">
            <h2 class="text-white text-xl font-bold tracking-tight">Escolha uma Organização</h2>
            <p class="text-zinc-400 text-sm mt-1">Selecione uma organização para continuar</p>
          </div>

          <!-- Lista de organizações -->
          <div class="space-y-3 mb-6">
            <!-- Barra de pesquisa -->
            <!-- <div class="relative mb-4">
              <input 
                type="text" 
                v-model="searchQuery" 
                placeholder="Buscar organização..." 
                class="w-full px-4 py-3 pl-10 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
              />
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-500 absolute left-3 top-1/2 transform -translate-y-1/2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.3-4.3"></path>
              </svg>
            </div> -->

            <div 
              v-for="organization in organizations"
              :key="organization.id"
              class="relative bg-white/5 hover:bg-white/10 border border-zinc-700 rounded-lg p-4 transition-all duration-200 cursor-pointer group"
              @click="continueToApp(organization)"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-3">
                  <div class="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center text-white font-bold">
                    {{ organization.name.charAt(0).toUpperCase() }}
                  </div>
                  <div>
                    <h3 class="text-white font-medium">{{ organization.name }}</h3>
                    <p class="text-zinc-400 text-sm">{{ organization.document }}</p>
                  </div>
                </div>
                <div class="flex items-center space-x-2">
                  <div class="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center transition-colors text-zinc-400 group-hover:text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"/>
                    </svg>
                  </div>
                  <div class="w-8 h-8 rounded-full bg-[#10B981]/10 flex items-center justify-center text-[#10B981] group-hover:bg-[#10B981] group-hover:text-white transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m9 18 6-6-6-6"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <Loader2 v-if="!organizations" class="w-10 h-10 animate-spin text-white mx-auto" />
          </div>

          <!-- Botão de criar organização -->
          <!-- <button 
            @click="createOrganization"
            class="w-full py-3.5 px-4 bg-[#10B981]/10 hover:bg-[#10B981]/20 text-[#10B981] font-medium rounded-lg transition-colors duration-200 flex items-center justify-center group"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 group-hover:rotate-90 transition-transform duration-300">
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>
            <span>Criar Nova Organização</span>
          </button> -->
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { useOrganization } from '@/composables/useOrganization'
import { Organization } from '@/interfaces/organizations/Organization'
import router from '@/router'
import { Loader2 } from 'lucide-vue-next'
import { onMounted, ref } from 'vue'

const organizations = ref<Organization[]>()
const { getAll, chooseOrganization } = useOrganization()

const continueToApp = (organization: Organization) => {
  chooseOrganization(organization)
  router.push({ name: 'home' })
}

onMounted(() => {
  getAll().then((data) => {
    organizations.value = data
  })
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

:root {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "cv02", "cv03", "cv04", "cv11";
  letter-spacing: -0.015em;
}
</style>